<template>
  <AdminLayout>
    <Head title="Adjustments" />

    <template #pageTitle>
      <div class="flex justify-between items-center">
        Adjustments
        <div class="relative text-right ml-3 -mt-1 inline-block">
          <div class="input-control">
            <ToggleSelector
              v-model="form.locations"
              :options="locations"
              selected-label="Locations"
            ></ToggleSelector>
          </div>
        </div>
        <div class="relative text-right ml-3 -mt-1 inline-block">
          <div class="input-control">
            <ToggleSelector
              v-model="form.statuses"
              :options="statuses"
              selected-label="Locations"
            ></ToggleSelector>
          </div>
        </div>
      </div>
    </template>

    <template #headingOptions>
      <button
        @click="openCreate()"
        type="button"
        class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-gray-100 bg-blue-600 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-600"
      >
        Create Adjustment
      </button>
    </template>

    <!-- content -->
    <data-table
      :items="data"
      :headers="headers"
      :actions="[]"
      :selectable="false"
    >
      <template v-slot:rows="slotRow">
        <index-row
          v-slot:rows="slotRow"
          v-bind="slotRow"
          @selected="showTransfer"
          :default-location-name="defaultLocationName"
        />
      </template>
    </data-table>

    <!--        <Pagination :page="adjustments.meta.current_page"-->
    <!--                    :total="adjustments.meta.total"-->
    <!--                    :per-page="adjustments.meta.per_page"-->
    <!--                    :path="adjustments.meta.path"-->
    <!--                    v-if="adjustments.meta.last_page > 1"-->
    <!--                    :params="params"-->
    <!--        />-->

    <template #modals>
      <CreateModal
        v-model:open="showingCreateModal"
        :action-text="'Create'"
        @created=""
      />
    </template>
  </AdminLayout>
</template>

<style scoped></style>

<script>
import AdminLayout from '@/Layouts/AdminLayout.vue'
import { Head, Link, useForm } from '@inertiajs/vue3'
import DataTable from '@/Components/Table/TransfersDataTable'
import { ChevronDownIcon, CheckCircleIcon } from '@heroicons/vue/solid'
import IndexRow from '@/Pages/Counts/Components/IndexRow'
import CreateModal from '@/Pages/Counts/Components/CreateModal'
import { Dialog, DialogOverlay, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'
import { XIcon } from '@heroicons/vue/outline'
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'
import Pagination from '@/Components/Pagination.vue'
import _datetime from '@/Filters/DateTime'
import accessesCompany from '@/Mixins/accessesCompany'

export default {
  mixins: [accessesCompany],

  components: {
    AdminLayout,
    Head,
    Link,
    DataTable,
    IndexRow,
    CreateModal,
    Dialog,
    DialogOverlay,
    DialogTitle,
    TransitionChild,
    TransitionRoot,
    XIcon,
    ChevronDownIcon,
    CheckCircleIcon,
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
    Pagination
  },

  props: {
    adjustments: {
      type: Object,
      default() {
        return {}
      }
    }
  },

  data() {
    return {
      showingCreateModal: false,
      form: this.$inertia.form({
        //
      }),
      data: [{}]
    }
  },

  computed: {
    headers() {
      return ['Name', 'Type', 'Initiated', 'Completed', 'Location', 'Status']
    }
  },

  methods: {
    _datetime,
    reload() {
      this.form.get(route('adjustments.index'))
    },
    showAdjustmentRoute(adjustment) {
      return route('adjustments.edit', { adjustment: adjustment.id })
    },
    openCreate() {
      this.showingCreateModal = true
    },
    closeCreate() {
      this.showingCreateModal = false
    }
  }
}
</script>
